import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueries, EXTERNAL_URL } from "@/services";
import { transformErrorResponse, transformSuccessResponse } from "@/services";

const { rawExternalApiBaseQuery: passwordVerificationAPIBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

export const passwordVerificationAPI = createApi({
    reducerPath: 'passwordVerificationAPI',
    baseQuery: passwordVerificationAPIBaseQuery,
    endpoints: (builder) => ({
        checkPassword: builder.query({
            query: (password) => ({
                url: `/auth/student/verify?password=${password}`,
                method: 'GET'
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),

        updateTwoFactorAuthentication: builder.mutation({
            query: (twoFactorAuthentication) => ({
                url: `/auth/student/twoFactor`,
                method: 'PATCH',
                body: { twoFactorAuthentication },
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),
    }),
});

export const {
    useLazyCheckPasswordQuery,
    useUpdateTwoFactorAuthenticationMutation,
} = passwordVerificationAPI;

export default passwordVerificationAPI;
